"use strict";
$(document).ready(function () {
  // MENU TOGGLE
  $('[data-toggle=menu]').on('click', function () {
    $('body').toggleClass('menu-on');
  });
  $(document).on('click', function (e) {
    if (!$(e.target).is('.nav-header *, [data-toggle=menu]')) {
      $('body').removeClass('menu-on');
    }
  });

  if ($('body').hasClass('menu-scrollspy')) {
    // FIXED MENU
    var fixedMenu = function () {
      var scrollTop = $(window).scrollTop();
      var menuOffstetTop = $('#mainmenu').offset().top;
      var footerHeight = $('#footer').outerHeight();
      var footerOffsetTop = $('#footer').offset().top;
      var windowHeight = $(window).outerHeight();
      var windowWidth = $(window).outerWidth();
      var menuHeight = $('#mainmenu .nav-main').outerHeight();
      if (windowWidth >= 1200) {
        if (scrollTop >= menuOffstetTop) {
          $('body').addClass('menu-fixed-on');
        }
        if (scrollTop < menuOffstetTop) {
          $('body').removeClass('menu-fixed-on');
        }
        if (scrollTop >= (footerOffsetTop - menuHeight)) {
          $('#mainmenu .nav-fixed__inner').css({'top': (footerOffsetTop - scrollTop - menuHeight)});
        }
        if (scrollTop < (footerOffsetTop - menuHeight)) {
          $('#mainmenu .nav-fixed__inner').attr('style', '');
        }
        if (windowHeight < menuHeight) {
          $('body').addClass('menu-fixed-full');
        }
        if (windowHeight >= menuHeight) {
          $('body').removeClass('menu-fixed-full');
        }
      } else {
        $('body').removeClass('menu-fixed-on').removeClass('menu-fixed-full');
        $('#mainmenu .nav-fixed__inner').attr('style', '');
      }
    };

    // UPDATE HASH LOCATION
    $(window).on('activate.bs.scrollspy', function (e) {
      var hash = $('.nav-main .active').attr('href');
      if (hash.length > 0) {
        history.replaceState({}, '', hash);
      }
    });

    // SCROLL TO HASH
    var scrollToHash = function () {
      var hash = window.location.hash;
      if (hash.length > 0) {
        $('html,body').animate({scrollTop: $('[data-id="' + hash + '"]').offset().top - 35}, 500);
      }
    };

    $('.nav-main .nav-link').on('click', function () {
      $('html,body').animate({scrollTop: $('[data-id="' + $(this).attr('href') + '"]').offset().top - 35}, 500);
    });

    fixedMenu();

    $(window).scroll(function () {
      fixedMenu();
      if ($('.nav-main .active').length == 0) {
        history.replaceState({}, '', '#');
      }
    });

    $(window).resize(function () {
      fixedMenu();
    });

    $(window).on('load', function () {
      scrollToHash();
    });

    $(window).on('hashchange', function () {
      scrollToHash();
    });
  }

});
